/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { Container, List, Segment } from 'semantic-ui-react';
import { map } from 'lodash';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { useSelector, shallowEqual } from 'react-redux';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL, addAppURL } from '@plone/volto/helpers';

const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  const { siteActions = [] } = useSelector(
    (state) => ({
      siteActions: state.actions?.actions?.site_actions,
    }),
    shallowEqual,
  );

  return (
    <Segment
      role="contentinfo"
      vertical
      padded
      inverted
      color="grey"
      textAlign="center"
      id="footer"
      aria-label="Footer"
    >
      <Container>
        <Segment basic inverted color="grey" className="discreet">
          <p>
            {' '}
            Except where otherwise stated site content is copyright{' '}
            <abbr title={intl.formatMessage(messages.copyright)}>©</abbr>2009-
            {new Date().getFullYear()} Ken Manheimer and available for sharing
            <br />
            under the{' '}
            <a className="item" href="https://creativecommons.org">
              Creative Commons
            </a>{' '}
            license:{' '}
            <a
              className="item"
              href="https://creativecommons.org/licenses/by-nc-sa/4.0/"
            >
              Attribution-NonCommercial-ShareAlike 4.0 Unported
            </a>
            .
            <br /> <a className="item" href="./contact-me"> Contact me </a> for other terms.
          </p>
        </Segment>
        <List horizontal inverted>
          {siteActions?.length
            ? map(siteActions, (item) => (
                <div role="listitem" className="item" key={item.id}>
                  <UniversalLink
                    className="item"
                    href={
                      item.url
                        ? /* KLM: Remove '.replace(...)' when mailhost is working */
                          flattenToAppURL(
                            item.url.replace('contact-form', 'contact-me'),
                          )
                        : addAppURL(item.id)
                    }
                  >
                    {item?.title}
                  </UniversalLink>
                </div>
              ))
            : null}
          <div role="listitem" className="item">
            <a className="item" href="https://plone.org">
              <FormattedMessage
                id="Powered by Plone & Python"
                defaultMessage="Powered by Plone & Python"
              />
            </a>
          </div>
        </List>
      </Container>
    </Segment>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
